"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getOptions;

var _lodash = require("lodash");

var _ColorPalette = _interopRequireDefault(require("./ColorPalette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = {
  mapType: "countries",
  countryCodeColumn: "",
  countryCodeType: "iso_a3",
  valueColumn: "",
  clusteringMode: "e",
  steps: 5,
  valueFormat: "0,0.00",
  noValuePlaceholder: "N/A",
  colors: {
    min: _ColorPalette.default["Light Blue"],
    max: _ColorPalette.default["Dark Blue"],
    background: _ColorPalette.default.White,
    borders: _ColorPalette.default.White,
    noValue: _ColorPalette.default["Light Gray"]
  },
  legend: {
    visible: true,
    position: "bottom-left",
    alignText: "right"
  },
  tooltip: {
    enabled: true,
    template: "<b>{{ @@name }}</b>: {{ @@value }}"
  },
  popup: {
    enabled: true,
    template: "Country: <b>{{ @@name_long }} ({{ @@iso_a2 }})</b>\n<br>\nValue: <b>{{ @@value }}</b>"
  }
};

function getOptions(options) {
  return (0, _lodash.merge)({}, DEFAULT_OPTIONS, options);
}
//# sourceMappingURL=getOptions.js.map